import { useStore } from '@nanostores/react';
import { useState, useCallback } from 'react';
import { AuthButtons } from './AuthButtons';
import { HeaderSocialLinks } from './HeaderSocialLinks';
import { NavigationItem } from './NavigationItem';
import { userStore } from '~/lib/stores/user';
import { classNames } from '~/utils/classNames';
import { getNavItemsMeta } from '~/utils/homepage-navbar-links';

interface MobileMainMenuProps {
  className?: string;
}

export const MobileMainMenu = ({ className }: MobileMainMenuProps) => {
  const [openMenu, setOpenMenu] = useState(false);

  const loggedIn = useStore(userStore.loggedIn);
  const navigationItems = getNavItemsMeta();

  const toggleMenu = useCallback(() => {
    setOpenMenu((v) => !v);
  }, [openMenu]);

  const displayAuthButtons = !loggedIn;

  return (
    <div className={classNames('lg:hidden flex', className)}>
      <button
        className="flex items-center justify-center p-2.5 rounded-md focus:outline-none bg-transparent"
        aria-label="Open menu"
        onClick={toggleMenu}
      >
        <span className="text-base i-heroicons:bars-3" />
      </button>

      {openMenu && (
        <div className="fixed inset-0 w-full h-[100dvh] flex flex-col bg-bolt-ds-surfaceOne rounded-none z-dialog pt-[8.5px] px-2 pb-2">
          <div className="flex items-center justify-end gap-3 pr-2">
            <HeaderSocialLinks />
            <button
              className="flex items-center justify-center p-2.5 rounded-md focus:outline-none bg-bolt-ds-surface-highlight"
              aria-label="Close menu"
              onClick={toggleMenu}
            >
              <span className="text-base i-ph:x" />
            </button>
          </div>

          <div className="overflow-y-auto flex flex-1 flex-col gap-2 h-full mt-2.5">
            {navigationItems.map((item, index) => (
              <NavigationItem
                key={index}
                item={item}
                className={classNames(
                  'p-2 rounded text-lg font-semibold text-bolt-ds-textPrimary focus:text-bolt-ds-textPrimary',
                  item.type === 'button' ? 'h-auto justify-start' : 'no-underline',
                )}
                onItemClick={toggleMenu}
              />
            ))}
          </div>

          {displayAuthButtons && <AuthButtons className="flex flex-col [&>button]:w-full px-2" />}
        </div>
      )}
    </div>
  );
};
